"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggedInDropdown = void 0;
const react_1 = __importDefault(require("react"));
const shared_1 = require("../../shared");
const utils_1 = require("../../utils");
const menu_1 = require("../menu");
const UserIconDisplayName_1 = require("./UserIconDisplayName");
const LoggedInDropdown = ({ dropdownLinks = [], signOutLink = (0, utils_1.defaultSignOutLink)(), displayName, rightAlign }) => {
    const { messages } = (0, shared_1.useMessages)();
    return (react_1.default.createElement(menu_1.SimpleDesktopDropdownMenu, { summaryNode: react_1.default.createElement(UserIconDisplayName_1.UserIconDisplayName, { displayName: displayName }), links: [...dropdownLinks, Object.assign({ title: messages.sign_out }, signOutLink)], dropdownAlignCenter: true, textAlignCenter: true, rightAlign: rightAlign, menuId: "logged-in" }));
};
exports.LoggedInDropdown = LoggedInDropdown;
//# sourceMappingURL=LoggedInDropdown.js.map